import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import * as domainConstants from '../../../constants/DomainConstants';
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import FinancieelTableComponent from "../parts/FinancieelTableComponent";
import { Popup } from 'semantic-ui-react';

const OpbrengstenForm = (props) => {
    const {
        model,
        color,
        okiTypes,
        disabled,
        goToOpbrengstEdit,
        showDeleteModal,
        goToOpbrengstEditWijzig
    } = props;

    function mapOnShowDeleteModal(id) {
        return function (event) {
            showDeleteModal(event, id);
        };
    }

    function mapOnEdit(id) {
        return function (event) {
            goToOpbrengstEditWijzig(event, id);
        };
    }

    const isIngediend = model.redenVanStatus.toString() === domainConstants.REDEN_VAN_STATUS_INGEDIEND;
    const noModelsContent = "Je hebt nog geen opbrengsten ingegeven voor deze opbrengstensoort.";

    const getContent = (titel, models, subtypes, showSubHeader) => {
        const subTypeModels = subtypes.map((subtype) => (
            {
                subtypeId: subtype.id,
                titel: subtype.titel,
                models: models.filter(m => m.subtypeId === subtype.id),
                opbrengstenOfKostenPosten: subtype.opbrengstenOfKostenPosten
            }
        ));
        const content = subTypeModels.map((subtypeModel) => {
            const tableSettings = {
                tableHeaders: ["OPBRENGSTENPOST", "OMSCHRIJVING", "TOTAAL", ""],
                tableHeaderSizes: [2, 7, 2, 1],
                noModelsContent: noModelsContent,
                hasRows: subtypeModel.models.length > 0,
                tableRows: subtypeModel.models.map((oki, i) => {
                    const opbrengstenOfKostenPost = subtypeModel.opbrengstenOfKostenPosten.find(m => m.value === oki.opbrengstenOfKostenPostId);
                    const opbrengstenOfKostenPostOmschrijving = opbrengstenOfKostenPost ? opbrengstenOfKostenPost.label : null;
                    const tdStyle = oki.volledig ? null : { color: 'orange' };

                    return (<tr key={"kostenopbrengensten_" + i}>
                        <td style={tdStyle}>{opbrengstenOfKostenPostOmschrijving}</td>
                        <td style={tdStyle}>{oki.omschrijving}</td>
                        <td style={tdStyle}>{"€ " + oki.bedragTotaal.toLocaleString('nl-BE')}</td>
                        <td>
                            {isIngediend ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={mapOnShowDeleteModal(oki.id)} />} content="verwijder opbrengstenpost" /></span>}
                            <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={mapOnEdit(oki.id)} />} content="wijzig opbrengstenpost" /></span>
                        </td>
                    </tr >);
                })
            };

            return (<div key={"SUBTYPE_" + subtypeModel.subtypeId}>
                {showSubHeader ? <FieldsetSubHeader>{subtypeModel.titel}</FieldsetSubHeader> : null}
                <FinancieelTableComponent
                    settings={tableSettings}
                    disabled={disabled} />
            </div>);
        });
        return <Fieldset title={titel}>{content}</Fieldset>;
    };

    const bedrijfsopbrengstType = okiTypes.find(m => m.id == domainConstants.KostenOpbrengstenInvesteringMainTypes.Bedrijfsopbrengst);
    const financieleOpbrengstType = okiTypes.find(m => m.id == domainConstants.KostenOpbrengstenInvesteringMainTypes.FinanciëleOpbrengst);
    const uitzonderlijkeOpbrengstType = okiTypes.find(m => m.id == domainConstants.KostenOpbrengstenInvesteringMainTypes.UitzonderlijkeOpbrengst);

    const bedrijfsopbrengstModels = model.opbrengstKostInvesteringen.filter(m => m.typeId == bedrijfsopbrengstType.id);
    const financieleOpbrengstModels = model.opbrengstKostInvesteringen.filter(m => m.typeId == financieleOpbrengstType.id);
    const uitzonderlijkeOpbrengstModels = model.opbrengstKostInvesteringen.filter(m => m.typeId == uitzonderlijkeOpbrengstType.id);

    const bedrijfsopbrengst = getContent("BEDRIJFSOPBRENGST", bedrijfsopbrengstModels, bedrijfsopbrengstType.subtypes, true);
    const financieleOpbrengst = getContent("FINANCIELE OPBRENGST", financieleOpbrengstModels, financieleOpbrengstType.subtypes, false);
    const uitzonderlijkeOpbrengst = getContent("UITZONDERLIJKE OPBRENGST", uitzonderlijkeOpbrengstModels, uitzonderlijkeOpbrengstType.subtypes, false);

    return (<Section title={domainConstants.FinancieelTitels.FinancieleDuurzaamheid} color={color}>
        <Form
            title="Overzicht opbrengsten"
            name="overzichtOpbrengsten"
            leftButtonLabel={isIngediend ? null : "Voeg opbrengsten toe"}
            onLeftButtonClick={goToOpbrengstEdit}
            rightTopButtonLabel={isIngediend ? null : "Voeg opbrengsten toe"}
            onRightTopButtonClick={goToOpbrengstEdit}
            isNotRequired>
            {bedrijfsopbrengst}
            {financieleOpbrengst}
            {uitzonderlijkeOpbrengst}
        </Form>
    </Section>);
};

OpbrengstenForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    okiTypes: PropTypes.array,
    model: PropTypes.object,
    goToOpbrengstEdit: PropTypes.func,
    showDeleteModal: PropTypes.func,
    goToOpbrengstEditWijzig: PropTypes.func
};

export default OpbrengstenForm;